import { combineReducers } from 'redux';
import { TARGETS_UPDATED, TARGET_CLEARED } from '../actions/diffusion';
import { INITIAL_DATA_LOAD_SUCCESS } from '../actions';

const targets = (state = [], action) => {
  switch (action.type) {
    case TARGETS_UPDATED:
    case INITIAL_DATA_LOAD_SUCCESS:
      return action.targets;
    case TARGET_CLEARED:
      return [];
    default:
      return state;
  }
};

export default combineReducers({
  targets,
});

export const getTargets = state => state.diffusion.targets;



// WEBPACK FOOTER //
// ./src/modules/survey/reducers/diffusion.js